export default __webpack_public_path__ + "static/media/planimg2.4be1f7be.png";